import serialize from 'serialize-javascript'

const jwtSecret = 'erP8j/Qe+4TeAg=='

const storageMap = {
  local: window.localStorage,
  session: window.sessionStorage
}

const BASE_KEY = '5.0.0'
const USER_KEY = 'user'

const createKey = key => [BASE_KEY, key].join('@')

/**
 * 根据name 获取值
 * @param {*}      key
 * @param type     Storage type
 * @returns {String} val
 */
export const getToken = (key, type = 'session') => {
  let tokenStr = ''
  let user = getStore(USER_KEY, type)
  if (user) {
    tokenStr = user[key] || ''
  }
  return tokenStr
}

/**
 *写入 sessionStorage
 * @param name     名称
 * @param content  内容
 * @param type     Storage type
 */
export const setStore = (name, content, type = 'session') => {
  if (!name || !content) return
  if (typeof content !== 'string') {
    // content = JSON.stringify(content)
    content = serialize(content, { isJSON: true })
  }
  storageMap[type].setItem(createKey(name), content)
}

/**
 *获取 sessionStorage
 * @param name  获取的名称
 * @param type  Storage type
 */
export const getStore = (name, type = 'session') => {
  let obj = ''
  if (!name) return
  let content = storageMap[type].getItem(createKey(name))
  if (content) {
    obj = JSON.parse(content)
  }
  return obj
}

/**
 *清空 sessionStorage
 * @param type Storage type
 */
export const clear = (type = 'session') => {
  storageMap[type].clear()
}

/**
 *获取 sessionStorage
 * @param name  获取的名称
 */
export const getCrmStore = (name, type = 'session') => {
  if (!name) return
  let content = storageMap[type].getItem(createKey(name))
  return content || ''
}

/**
 *获取 sessionStorage 中的某一项
 * @param name  获取的session key
 * @param type  Storage type
 */
export const getItem = (name, type = 'session') => {
  return getStore('users', type)[name]
}

/**
 * 删除
 * @param name
 * @param type  Storage type
 */
export const removeStore = (name, type = 'session') => {
  if (!name) return
  storageMap[type].removeItem(name)
}

export const getCookie = key => {
  const arr1 = document.cookie.split('; ') // 由于cookie是通过一个分号+空格的形式串联起来的，所以这里需要先按分号空格截断,变成[name=Jack,pwd=123456,age=22]数组类型；
  for (let i = 0; i < arr1.length; i++) {
    const arr2 = arr1[i].split('=') // 通过=截断，把name=Jack截断成[name,Jack]数组；
    if (arr2[0] === key) {
      return decodeURI(arr2[1])
    }
  }
}

export const setCookie = (key, val, time) => {
  const date = new Date() // 获取当前时间
  const expiresDays = time || 1 // 将date设置为n天以后的时间
  date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000) // 格式化为cookie识别的时间
  document.cookie = key + '=' + val + ';expires=' + date.toGMTString() // 设置cookie
}

export const removeCookie = key => {
  const date = new Date() // 获取当前时间
  date.setTime(date.getTime() - 10000) // 将date设置为过去的时间
  document.cookie = key + '=v;expires=' + date.toGMTString() // 设置cookie
}
